import React, { useState, useEffect } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Controls from "../components/FormsUI";
import { useAuth } from "../utility/auth";
import InternetProfileController from "../controller/InternetProfileController";
import MastersController from "../controller/MastersController";
import CustomizedSnackbars from "../components/Alert";
import "../css/style.css";
import { tokens } from "../theme";
import moment from "moment";
import dayjs from "dayjs";
import Load from "../components/FormsUI/Loader/index";
import { Container, Grid, useTheme, Box, InputLabel } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ImagePreview from "../components/FormsUI/PreviewImage/index";
import ExceptionHandlerController from "../controller/ErrorLogsController";
const numberRegEx = /^[0-9\b]+$/;
const URLRegEx = /^(ftp|http|https):\/\/[a-zA-Z0-9_.%\-/]+$/;
const domainRegEX = /^[a-zA-Z0-9_.%\-/]+$/;
const INITIAL_FORM_STATE = {
  domainWebsite: "",
  facebook: "",
  favicon: "",
  twitter: "",
  linkedIn: "",
  clubPanNo: "",
  clubNo: "",
  charityNo: "",
  clubGSTNo: "",
  region: "",
  zone: "",
  instagram: "",
  youtubeChannelId: "",
  districtLogo: "",
  district: "",
  charteredDate: "",
  totalMembers: "",
  clubContactNo: "",
  memberShipContactNo: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  pincode: "",
  clubLogo: "",
  clubEmailId: "",
  metadataKeyword: "",
  metadataDescriprition: "",
  contactNo1: "",
  contactNo2: "",
  footer: "",
};

const FORM_VALIDATION = Yup.object().shape({
  domainWebsite: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(domainRegEX, "Invalid URL example: itmines.com/")
    .required("Domain Website is required")
    .max(50, "Maximum 50 characters allowed only"),
  facebook: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(
      URLRegEx,
      "Facebook id invalid  example: https://www.facebook.com/itmines/posts/"
    )
    .optional()
    .max(50, "Maximum 50 characters allowed only"),
  twitter: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(
      URLRegEx,
      "X id invalid  example: https://www.twitter.com/itmines/posts/"
    )
    .optional()
    .max(50, "Maximum 50 characters allowed only"),
  youtubeChannelId: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional()
    .max(50, "Maximum 50 characters allowed only"),
  instagram: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(
      URLRegEx,
      "Instagram id invalid  example: https://www.instagram.com/itmines/posts/"
    )
    .optional()
    .max(50, "Maximum 50 characters allowed only"),
  linkedIn: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(
      URLRegEx,
      "linkedIn id invalid  example: https://www.linkedin.com/itmines/posts/"
    )
    .optional()
    .max(50, "Maximum 50 characters allowed only"),
  clubGSTNo: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9][A-Z0-9][A-Z0-9]$/,
      "Invalid GST number"
    )
    .optional(),
  clubPanNo: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(/^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/, "Incorrect PAN format")
    .optional(),
  clubNo: Yup.string().trim("No white space allowed").strict(true).optional(),
  charityNo: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  region: Yup.string().trim("No white space allowed").strict(true).optional(),
  zone: Yup.string().trim("No white space allowed").strict(true).optional(),
  district: Yup.string().trim("No white space allowed").strict(true).optional(),
  charteredDate: Yup.string().optional(),
  totalMembers: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  clubContactNo: Yup.string()
    .trim("No white space allowed")
    .min(10, "Club Contact No must be at least 10 characters")
    .strict(true)
    .optional(),
  memberShipContactNo: Yup.string()
    .trim("No white space allowed")
    .min(10, "Membership Contact No must be at least 10 characters")
    .strict(true)
    .optional(),
  address1: Yup.string().trim("No white space allowed").strict(true).optional(),
  address2: Yup.string().trim("No white space allowed").strict(true).optional(),
  city: Yup.string().trim("No white space allowed").strict(true).optional(),
  state: Yup.string().trim("No white space allowed").strict(true).optional(),
  pincode: Yup.string().trim("No white space allowed").strict(true).optional(),
  clubEmailId: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(/^[^\s@]+@[^\s@]+$/, "Enter a valid e-mail")
    .optional(),
  metadataKeyword: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  metadataDescriprition: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .optional(),
  contactNo1: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(/^\d{10}$/, "Contact No 1 must be valid Mobile Number")
    .optional(),
  contactNo2: Yup.string()
    .trim("No white space allowed")
    .strict(true)
    .matches(/^\d{10}$/, "Contact No 2 must be valid Mobile Number")
    .optional(),
  footer: Yup.string().trim("No white space allowed").strict(true).optional(),
});
const internetController = new InternetProfileController();
const exceptionHandlerController = new ExceptionHandlerController();
const mastersController = new MastersController();

const InternetProfile = () => {
  const auth = useAuth();
  const user = auth.decoder(sessionStorage.getItem("user"));
  const [alert, setAlert] = useState({ counter: 0, type: "", msg: "" });
  const { data, token } = user;
  const [updatedValues, setUpdatedValues] = useState(INITIAL_FORM_STATE);
  const theme = useTheme();
  // const { userid: tenantId } = data.UserInfo;
  const { userid: userId, tenantid: tenantId } = data.UserInfo;
  const colors = tokens(theme.palette.mode);
  const [pincodeData, setPincodeData] = useState({
    state: "",
    city: "",
  });
  const [numberMinMax, setNumberMinMax] = useState({
    totalMembers: "",
    clubContactNo: "",
    memberShipContactNo: "",
    contactNo1: "",
    contactNo2: "",
  });
  const [loader, setLoader] = useState(false);
  const [clubLogo, setClubLogo] = useState();
  const [districtLogo, setDistrictLogo] = useState();
  const [popupPreview, setPopUpPreview] = useState({
    districtLogo: false,
    clubLogo: false,
  });
  const previewPopUpImage = (field, value) =>
    setPopUpPreview((prev) => ({ ...prev, [field]: value }));
  const [internetProfileId, setInternetProfileId] = useState();
  const [fileFavicon, setFileFavicon] = useState();
  const [fileClubLogo, setFileClubLogo] = useState();
  const [fileDistrictLogo, setFileDistrictLogo] = useState();
  const [favicon, setFavicon] = useState();

  useEffect(() => {
    const getInternetProfile = async () => {
      try {
        const result = await internetController.Get(tenantId, token);
        handleResponse(result);
      } catch (error) {
        handleErrorGetInternetProfile(error);
      }
    };

    const handleResponse = (result) => {
      setLoader(false);
      if (result?.status === 200) {
        const responseData = result?.data?.body;
        updateState(responseData);
        handleAssets(responseData);
      } else {
        setLoader(false);
      }
    };

    const handleErrorGetInternetProfile = (error) => {
      setLoader(false);
      logError(error);
    };

    const logError = (err) => {
      const logData = {
        message: err?.message,
        stack: err?.stack,
      };
      const logErrorData = { logData, module: "Profile page Get method" };
      exceptionHandlerController.HandleException(logErrorData);
    };

    const updateState = (updatedData) => {
      setNumberMinMax((prev) => ({
        ...prev,
        pincode: updatedData?.pincode ?? "",
        totalMembers: updatedData?.totalMembers ?? "",
        clubContactNo: updatedData?.clubContactNo ?? "",
        memberShipContactNo: updatedData?.memberShipContactNo ?? "",
        contactNo1: updatedData?.contactNo1 ?? "",
        contactNo2: updatedData?.contactNo2 ?? "",
      }));

      setPincodeData((prev) => ({
        ...prev,
        state: updatedData?.state ?? "",
        city: updatedData?.city ?? "",
      }));

      setUpdatedValues(updatedData);
      setInternetProfileId(updatedData?.internetProfileId);
    };

    const handleAssets = (updatedLogos) => {
      if (updatedLogos?.favicon) {
        updateAsset(updatedLogos.favicon, setFavicon, setFileFavicon);
      }

      if (updatedLogos?.districtLogo) {
        updateAsset(updatedLogos.districtLogo, setDistrictLogo, setFileDistrictLogo);
      }

      if (updatedLogos?.clubLogo) {
        updateAsset(updatedLogos.clubLogo, setClubLogo, setFileClubLogo);
      }
    };

    const updateAsset = (url, setLogo, setFile) => {
      setLogo(url);
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => setFile(blob))
        .catch((error) => console.error("Error fetching asset:", error));
    };

    // Start fetching the internet profile
    getInternetProfile();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const getLocation = (pincode) => {
    mastersController.GetLocation({ pincode }).then((result) => {
      if (result?.status === 200) {
        const fetchedLocation = result?.data?.body?.pincode;
        setPincodeData({
          state: fetchedLocation?.state,
          city: fetchedLocation?.city,
        });
      } else {
        setPincodeData({ state: "", city: "" });
        showAlert("error", "Invalid Pincode. Please Re-enter Pincode.");
      }
    });
  };
  const showAlert = (type, msg) => {
    const notify = { ...alert };
    notify.counter = notify?.counter + 1;
    notify.type = type;
    notify.msg = msg;
    setAlert(notify);
  };
  const saveFile = ({ e, setFieldValue, field }) => {
    try {
      const file = e?.target?.files[0];
      if (!file) return;

      const fileSizeInMB = file.size / (1024 * 1024);
      if (fileSizeInMB > 4) {
        showAlert("error", "Document size should not be more than 4MB");
        return false;
      }

      const extFile = getFileExtension(file.name);
      if (!isValidImageExtension(extFile)) {
        showAlert("error", "Only jpeg, jfif, png and jpg images are allowed");
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        handleFileLoad(reader.result, field, setFieldValue, file);
      reader.onerror = handleFileError;
    } catch (error) {
      errorSaveFile(error);
    }
  };

  const getFileExtension = (filename) => {
    return filename.split(".").pop().toLowerCase();
  };

  const isValidImageExtension = (ext) => {
    return ["jpg", "jpeg", "png", "jfif"].includes(ext);
  };

  const handleFileLoad = (documentImg, field, setFieldValue, file) => {
    const img = new Image();
    img.onload = () => {
      if (field === "favicon") {
        validateFaviconSize(img.width, img.height);
      }
      setFieldValue(field, documentImg);
      updateFileState(field, documentImg, file);
    };
    img.src = documentImg;
  };

  const validateFaviconSize = (width, height) => {
    if (width > 32 || height > 32) {
      showAlert("error", "Favicon size should be 32x32 or 16x16 pixels");
      return false;
    }
  };

  const updateFileState = (field, documentImg, file) => {
    if (field === "favicon") {
      setFileFavicon(file);
      setFavicon(documentImg);
    } else if (field === "clubLogo") {
      setFileClubLogo(file);
      setClubLogo(documentImg);
    } else if (field === "districtLogo") {
      setFileDistrictLogo(file);
      setDistrictLogo(documentImg);
    }
  };

  const handleFileError = () => {
    showAlert(
      "error",
      "Unable to read the selected file. Please check the file format."
    );
    setTimeout(() => setAlert({ counter: 0, type: "", msg: "" }), 10000);
  };

  const errorSaveFile = (error) => {
    let logData = {
      message: error.message,
      stack: error.stack,
    };
    const logErrorData = { logData, module: "Profile saveFile method" };
    exceptionHandlerController.HandleException(logErrorData);
  };

  const submitValues = (dataValues) => {
    try {
      prepareDataValues(dataValues);
      dataValues.internetProfileId = internetProfileId
      const formData = createFormData(dataValues);

      if (!internetProfileId) {
        createInternetProfile(formData);
      } else {
        updateInternetProfile(formData);
      }
    } catch (error) {
      logErrorSubmit(error);
    }
  };

  const prepareDataValues = (dataValues) => {
    dataValues.tenantId = tenantId;
    dataValues.state = pincodeData?.state ?? "";
    dataValues.city = pincodeData?.city ?? "";
  };

  const createFormData = (dataValues) => {
    const formData = new FormData();
    for (const key in dataValues) {
      if (!["favicon", "clubLogo", "districtLogo"].includes(key)) {
        formData.append(key, dataValues[key]);
      }
    }
    if (fileFavicon) formData.append("favicon", fileFavicon);
    if (fileClubLogo) formData.append("clubLogo", fileClubLogo);
    if (fileDistrictLogo) formData.append("districtLogo", fileDistrictLogo);
    return formData;
  };

  const createInternetProfile = (formData) => {
    internetController
      .Create(formData, token)
      .then(handleCreateResponse)
      .catch(() => showAlert("error", "Oops something went wrong."));
  };

  const updateInternetProfile = (formData) => {
    internetController
      .Update(formData, token)
      .then(handleUpdateResponse)
      .catch((error) => {
        showAlert("error", "Something went wrong.");
      });
  };

  const handleCreateResponse = (response) => {
    if (response?.status === 201) {
      setInternetProfileId(response?.data?.body?.internetProfileId);
      showAlert("success", response?.data?.message);
    } else {
      showAlert("error", response?.response?.data?.message);
    }
  };

  const handleUpdateResponse = (response) => {
    if (response?.data?.status === 200) {
      setInternetProfileId(response?.data?.body?.internetProfileId);
      showAlert("success", response?.data?.message);
    } else {
      showAlert("error", response?.response?.data?.message);
    }
  };

  const logErrorSubmit = (error) => {
    const logData = {
      message: error.message,
      stack: error.stack,
    };
    const logErrorProfile = { logData, module: "Profile submit method" };
    exceptionHandlerController.HandleException(logErrorProfile);
  };

  if (loader) return <Load />;
  return (
    <div className="main-content">
      <Box
        sx={{
          "& .formBg": {
            border: `1px solid ${colors.grey[900]}`,
            background: `${colors.primary[400]}`,
          },
          "& li.MuiBreadcrumbs-li h6": { color: `${colors.primary[200]}` },
          "& .MuiGrid-root.Mui-heading h2": {
            color: `${colors.primary[200]} !important`,
          },
        }}
      >
        <Grid container>
          <Grid className="breadcrumb-section">
            <Grid className="breadcrumb-container">
              <Grid className="Mui-li">
                <nav className="Mui-nav" aria-label="breadcrumb">
                  <ol className="">
                    <li className="MuiBreadcrumbs-li">
                      <h6 className="breadsub">Home</h6>
                    </li>
                    <li aria-hidden="true" className="MuiBreadcrumbs-separator">
                      /
                    </li>
                    <li className="MuiBreadcrumbs-li">
                      <h6>Profile</h6>
                    </li>
                  </ol>
                </nav>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="formBg">
            <Container maxWidth="md" className="formClwidth">
              <div>
                <Formik
                  enableReinitialize
                  initialValues={{ ...(updatedValues || INITIAL_FORM_STATE) }}
                  validationSchema={FORM_VALIDATION}
                  onSubmit={(values) => submitValues(values)}
                >
                  {({
                    values,
                    setFieldValue,
                    setFieldTouched,
                    handleBlur,
                    handleChange,
                  }) => (
                    <Form encType="multipart/form-data">
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="domainWebsite"
                            label={
                              <span>
                                Domain Website{" "}
                                <span className="asterisk">*</span>
                              </span>
                            }
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="clubPanNo"
                            label="Club PAN Number"
                            type="string"
                            inputProps={{ maxLength: 10 }}
                            onChange={({ target: { value } }) => {
                              const updatedValue = value
                                ? value.toUpperCase()
                                : "";
                              setFieldValue("clubPanNo", updatedValue);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="clubNo"
                            label="Club Number"
                            type="string"
                            inputProps={{ maxLength: 20 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="charityNo"
                            label="Charity Number"
                            type="string"
                            inputProps={{ maxLength: 20 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="clubGSTNo"
                            label="Club GST Number"
                            type="string"
                            placeholder="00AAAAA0000A0A0"
                            inputProps={{ maxLength: 15 }}
                            onChange={({ target: { value } }) => {
                              const updatedValue = value
                                ? value.toUpperCase()
                                : "";
                              setFieldValue("clubGSTNo", updatedValue);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="region"
                            label="Region"
                            type="string"
                            inputProps={{ maxLength: 30 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="zone"
                            label="Zone"
                            type="string"
                            inputProps={{ maxLength: 30 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="youtubeChannelId"
                            label="YouTube Channel Id"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="instagram"
                            label="Instagram"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="facebook"
                            label="Facebook"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="twitter"
                            label="X"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="linkedIn"
                            label="Linked In"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="district"
                            label="District"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.DateTimePicker
                            id="charteredDate"
                            name="charteredDate"
                            label="Chartered Date"
                            value={
                              values?.charteredDate
                                ? dayjs(values?.charteredDate, "DD/MM/YYYY")
                                : null
                            }
                            onChange={(e) => {
                              setFieldTouched("charteredDate", true);
                              if (e === null || e === "") {
                                setFieldValue("charteredDate", "");
                              } else {
                                setFieldValue(
                                  "charteredDate",
                                  moment(new Date(e))?.format("DD/MM/YYYY")
                                );
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="totalMembers"
                            label="Total Members"
                            inputProps={{ maxLength: 4 }}
                            // value={numberMinMax?.totalMembers}
                            onChange={(event) => {
                              const { value } = event?.target;
                              if (value) {
                                if (numberRegEx.test(value)) {
                                  setNumberMinMax((prev) => ({
                                    ...prev,
                                    totalMembers: value,
                                  }));
                                  setFieldValue("totalMembers", value);
                                }
                              } else {
                                setFieldValue("totalMembers", value);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="clubContactNo"
                            label="Club Contact No"
                            type="string"
                            inputProps={{ maxLength: 15 }}
                            onChange={(event) => {
                              const { value } = event?.target;
                              if (value) {
                                if (numberRegEx.test(value)) {
                                  setNumberMinMax((prev) => ({
                                    ...prev,
                                    clubContactNo: value,
                                  }));
                                  setFieldValue("clubContactNo", value);
                                }
                              } else {
                                setFieldValue("clubContactNo", value);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="memberShipContactNo"
                            label="Membership Contact No"
                            type="string"
                            inputProps={{ maxLength: 15 }}
                            onChange={(event) => {
                              const { value } = event?.target;
                              if (value) {
                                if (numberRegEx.test(value)) {
                                  setNumberMinMax((prev) => ({
                                    ...prev,
                                    memberShipContactNo: value,
                                  }));
                                  setFieldValue("memberShipContactNo", value);
                                }
                              } else {
                                setFieldValue("memberShipContactNo", value);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="address1"
                            label="Adress Line 1"
                            type="string"
                            inputProps={{ maxLength: 150 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="address2"
                            label="Address Line 2"
                            type="string"
                            inputProps={{ maxLength: 150 }}
                          />
                        </Grid>
                        <Grid item xs={6} md={6}>
                          <Controls.Textfield
                            name="pincode"
                            label="Pincode"
                            type="string"
                            onBlur={(e) => {
                              setFieldTouched("pincode", true, true);
                              const { value } = e.target;
                              if (value?.length === 6) {
                                getLocation(Number(value));
                              }
                              handleBlur(e);
                            }}
                            inputProps={{ maxLength: 6 }}
                            value={numberMinMax.pincode || ""}
                            onChange={(e) => {
                              const { value } = e.target;
                              if (numberRegEx.test(value) || value === "") {
                                if (value === "") {
                                  setPincodeData({
                                    state: "",
                                    city: "",
                                    country: "",
                                  });
                                }
                                setNumberMinMax((prev) => ({
                                  ...prev,
                                  pincode: value,
                                }));
                                setFieldValue("pincode", value);
                                setFieldTouched("pincode", true, true);
                              }
                              handleChange(e);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="city"
                            label="City"
                            value={pincodeData?.city}
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="state"
                            label="State"
                            value={pincodeData?.state}
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="clubEmailId"
                            label="Club Email-Id"
                            type="string"
                            inputProps={{ maxLength: 50 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="metadataKeyword"
                            label="Metadata Keyword"
                            type="string"
                            inputProps={{ maxLength: 250 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="metadataDescriprition"
                            label="Metadata Descriprition"
                            type="string"
                            inputProps={{ maxLength: 350 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="contactNo1"
                            label="Contact No 1"
                            type="string"
                            onChange={(event) => {
                              const { value } = event?.target;
                              if (value) {
                                if (numberRegEx.test(value)) {
                                  setNumberMinMax((prev) => ({
                                    ...prev,
                                    contactNo1: value,
                                  }));
                                  setFieldValue("contactNo1", value);
                                }
                              } else {
                                setFieldValue("contactNo1", value);
                              }
                            }}
                            inputProps={{ maxLength: 10 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Controls.Textfield
                            name="contactNo2"
                            label="Contact No 2"
                            // value={values?.contactNo2 }
                            type="string"
                            onChange={(event) => {
                              const { value } = event?.target;
                              if (value) {
                                if (numberRegEx.test(value)) {
                                  setNumberMinMax((prev) => ({
                                    ...prev,
                                    contactNo2: value,
                                  }));
                                  setFieldValue("contactNo2", value);
                                }
                              } else {
                                setFieldValue("contactNo2", "");
                              }
                            }}
                            inputProps={{ maxLength: 10 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <Controls.Textfield
                            name="footer"
                            label="Footer"
                            type="string"
                            inputProps={{ maxLength: 300 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <h3 className="upload">
                            Club Logo <span className="asterisk">*</span>
                          </h3>
                          <Grid className="col-lg-10 col-md-10 l-float">
                            <input
                              type="file"
                              onChange={(e) => {
                                let field = "clubLogo";
                                saveFile({ e, setFieldValue, field });
                              }}
                              className="fileupload ipfile"
                            />
                          </Grid>
                          <Grid className="col-lg-2 col-md-2 l-float ml-1">
                            {clubLogo && (
                              <img
                                src={clubLogo}
                                width="55"
                                style={{ cursor: "pointer" }}
                                height="55"
                                onClick={() =>
                                  setPopUpPreview((prev) => ({
                                    ...prev,
                                    clubLogo: true,
                                  }))
                                }
                                alt="Logo"
                                className="imgview"
                              />
                            )}

                            <ImagePreview
                              image={clubLogo}
                              popup={popupPreview?.clubLogo}
                              field={"clubLogo"}
                              handlePopup={previewPopUpImage}
                            />
                          </Grid>
                          <ErrorMessage name="clubLogo">
                            {(msg) => (
                              <div style={{ color: "#d32f2f" }}>{msg}</div>
                            )}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Grid className="col-lg-12 col-md-12">
                            <h3 className="upload">District Logo</h3>
                            <Grid className="col-lg-10 col-md-10 l-float">
                              <input
                                type="file"
                                onChange={(e) => {
                                  let field = "districtLogo";
                                  saveFile({ e, setFieldValue, field });
                                }}
                                className="fileupload ipfile"
                              />
                            </Grid>
                            <Grid className="col-lg-2 col-md-2 l-float ml-1">
                              {districtLogo && (
                                <img
                                  src={districtLogo}
                                  width="55"
                                  style={{ cursor: "pointer" }}
                                  height="55"
                                  onClick={() =>
                                    setPopUpPreview((prev) => ({
                                      ...prev,
                                      districtLogo: true,
                                    }))
                                  }
                                  alt="Logo"
                                  className="imgview"
                                />
                              )}
                              <ImagePreview
                                image={districtLogo}
                                popup={popupPreview?.districtLogo}
                                field={"districtLogo"}
                                handlePopup={previewPopUpImage}
                              />
                            </Grid>
                            <ErrorMessage name="districtLogo">
                              {(msg) => (
                                <div style={{ color: "#d32f2f" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Grid className="col-lg-12 col-md-12">
                            <h3 className="upload">
                              Upload Favicon <span className="asterisk">*</span>
                            </h3>
                            <Grid className="col-lg-10 col-md-10 l-float">
                              <input
                                type="file"
                                onChange={(e) => {
                                  let field = "favicon";
                                  saveFile({ e, setFieldValue, field });
                                }}
                                className="fileupload ipfile"
                              />
                            </Grid>
                            <Grid className="col-lg-2 col-md-2 l-float ml-1">
                              {favicon && (
                                <img
                                  src={favicon}
                                  width="32"
                                  height="32"
                                  style={{ cursor: "pointer" }}
                                  alt="Favicon"
                                  className="imgview"
                                />
                              )}
                            </Grid>
                            <Grid className="col-lg-12 col-md-12 l-float">
                              <InfoIcon className="infoicon" />
                              <InputLabel
                                className="infotext"
                                sx={{ color: "black", font: "inherit" }}
                              >
                                Favicon should be either 32 * 32 or 16 * 16
                              </InputLabel>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid item xs={4} md={2} className="marginAuto">
                            <Controls.Button>Submit</Controls.Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
                {alert?.counter > 0 && (
                  <CustomizedSnackbars
                    status={alert?.counter}
                    msg={alert?.msg}
                    type={alert?.type}
                  />
                )}
              </div>
            </Container>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default InternetProfile;
